import React, { memo } from "react";
import { useIntl } from "react-intl";
import cls from "classnames";
import images from "../../../images";

interface ChildProps {
  text: string;
  index: number;
  isActive?: boolean;
  counter?: number;
  onClick?: (e) => void;
  icon?: keyof typeof images;
  newIcon?: keyof typeof images;
}

const ChildNavItem = ({
  text,
  index,
  isActive = false,
  counter,
  onClick,
  icon,
  newIcon,
}: ChildProps): JSX.Element => {
  const intl = useIntl();

  const theClassName = cls(
    "pl-7 py-2 pr-10 cursor-pointer group flex items-center font-semibold leading-5 text-gray-900 text-13px focus:outline-none focus:bg-gray-100 hover:text-gray-900 hover:bg-gray-200 transition ease-in-out duration-150",
    {
      "text-gray-500 bg-gradient-to-r from-ground-gradiant-100 border-r-4 border-ground-blue-100":
        isActive,
    }
  );

  return (
    <a
      id={text}
      data-cy={text}
      data-testid={index}
      onClick={onClick}
      className={theClassName}
    >
      {icon && <img src={images[icon]} alt="" />}

      <span className="truncate pl-3 flex items-center">
        {intl.formatMessage({ id: text })}
        {counter && counter > 0 && (
          <span
            className="ml-4 inline-block py-0.5 px-3 text-xs text-white leading-4 rounded-full bg-red-500 transition ease-in-out duration-150"
            aria-label={intl.formatMessage(
              { id: "notifications.count", defaultMessage: "{count} new" },
              { count: counter }
            )}
          >
            {counter}
          </span>
        )}
      </span>

      {newIcon && <img src={images[newIcon]} alt="" />}
    </a>
  );
};

export default memo(ChildNavItem);
